import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
} from "../../common/network-call";
import { INSTANCE_URL, itemCount } from "../../common/constant";

export const BADGE_LIST = "BADGE_LIST";

export function fetchBagdeList(session, companyid, pageCount = 0, callback) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${perPage}&offset=${offset}`;

  var url = `${INSTANCE_URL}/api/v2/tikwash_script/`;

  var body = {
    companyid: companyid,
    type: "company_vehicle",
    isbadge: 1,
    offset: offset,
    limit: perPage,
  };
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: BADGE_LIST,
          payload: { data: response.result, count: response.count },
        });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };

  // var url = `${INSTANCE_URL}/api/v2/tikwash/_table/company_vehicles?caller=web&related=device_usage_cost_by_company_vehicle_program&filter=((hruserid=${session.userid})AND(isbadge=1))&include_count=true&order=vehicleid%20DESC${offSetQuery}`;
  // return (dispatch) => {
  //   getRequest(
  //     url,
  //     session,
  //     dispatch,
  //     (response) => {
  //       dispatch({
  //         type: BADGE_LIST,
  //         payload: { data: response.resource, count: response.meta.count },
  //       });
  //       callback({ success: 1 });
  //     },
  //     (error) => {
  //       // callback({success: 0, error: error});
  //     }
  //   );
  // };
}
